import React from 'react';
import PropTypes from 'prop-types';

class RelatedProperties extends React.Component {
  static propTypes = {
    properties: PropTypes.array.isRequired
  }

  propertyDetails = (property) => {
    const relationship = property.relationship;
    const durationStart = property.durationStart;
    const durationEnd = property.durationEnd;
    if (!durationStart || !durationEnd) return relationship;

    const currentYear = new Date().getFullYear();
    const startYear = new Date(durationStart).getFullYear();
    let endYear = new Date(durationEnd).getFullYear();
    if (endYear === currentYear) endYear = 'Present';

    return `${relationship} • ${startYear} - ${endYear}`;
  }

  renderRows = () => {
    const { properties } = this.props;

    return properties.map(property => (
      <tr key={`${property.name}-${property.relationship}`}>
        <td>
          <a href={property.url}>
            {property.name}
          </a>
        </td>
        <td className="text-end text-muted">
          {this.propertyDetails(property)}
        </td>
      </tr>
    ));
  }

  render() {
    const { properties } = this.props;
    if (properties.length === 0) return null;

    return (
      <>
        <div className="fw-semibold">
          Related Properties
        </div>
        <table className="table mb-0">
          <tbody>
            {this.renderRows()}
          </tbody>
        </table>
      </>
    );
  }
}

export default RelatedProperties;
